export default "/images/PersonalCareIndustries.webp?5acbc8962d3d59069fcc38222a40298f";